
// 本配置文件配置了中文页面相关文案
import common from './zh-cn/common'
import error from './zh-cn/error'
import topology from './zh-cn/topo'
import header from './zh-cn/header'
import incomeAssessment from './zh-cn/incomeAssessment'
import energyConsumpiton from './zh-cn/energyConsumption'
import userBehaviorAnalysis from './zh-cn/userBehaviorAnalysis'
import workOrder from './zh-cn/workOrder'
import nav from './zh-cn/nav'
import maps from './zh-cn/maps'
import alert from './zh-cn/alert'
import strategyOptimize from './zh-cn/strategyOptimize'
import login from './zh-cn/login'
import sparePartsManagement from './zh-cn/sparePartsManagement'
import opsReportAnalysis from './zh-cn/opsReportAnalysis'
import projectFiles from './zh-cn/projectFiles'
export default {
	common: common,
	error: error,
    topo: topology,
    header: header,
	maps: maps,
	incomeAssessment: incomeAssessment,
	energyConsumption: energyConsumpiton,
	userBehaviorAnalysis: userBehaviorAnalysis,
	workOrder: workOrder,
    nav: nav,
	alert: alert,
    opsReportAnalysis: opsReportAnalysis,
	strategyOptimize: strategyOptimize,
	projectFiles: projectFiles,
    login: login,
	sparePartsManagement: sparePartsManagement,
};



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn.js